import api from "../api";
import {clearAccessToken, setAccessToken} from "../api";

export const login = async (email, password) => {
    try {
        const response = await api.post(
            "/v1/staff/auth/login",
            {email, password},
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        const data = response.data;

        if (data?.access_token && data?.user) {
            setAccessToken(data.access_token);
            return data.user;
        } else {
            throw new Error("error_unexpected_response");
        }
    } catch (error) {
        console.error("Login error:", error);
        if (error.response) {
            if (error.response.status === 401) {
                throw new Error("error_incorrect_credentials");
            }
            if (error.response.status === 403) {
                throw new Error("error_unauthorized");
            }
            if (error.response.status >= 500) {
                throw new Error("error_server");
            }
        } else if (error.request) {
            throw new Error("error_no_response");
        } else {
            throw new Error("error_general");
        }
    }
};

export const register = async (
    firstName,
    lastName,
    email,
    password,
    userRole,
    organizationId,
    token
) => {
    try {
        const response = await api.post(
            "/register",
            {
                firstName,
                lastName,
                email,
                password,
                userRole,
                organizationId,
                token
            },
            {}
        );

        if (!(response.status === 201)) {
            throw new Error("error_registration_failed");
        }

        const data = await response.data;

        if (data) {
            return true;
        } else {
            throw new Error("error_registration_failed");
        }
    } catch (error) {
        throw error.message;
    }
};

export const forgetPassword = async (email) => {
    try {
        const response = await api.post(
            "/forgot_password",
            {email},
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (!(response.status === 200)) {
            throw new Error("error_invalid_email");
        }

        const data = await response.data;

        if (data) {
            return true;
        } else {
            throw new Error("error_invalid_email");
        }
    } catch (error) {
        throw error.message;
    }
};

export const changePassword = async (email, oldPassword, newPassword) => {
    try {
        const response = await api.post(
            "/change-password",
            { email, oldPassword, newPassword },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 200) {
            return true;
        } else {
            throw new Error("error_password_change_failed");
        }
    } 
    catch (error) {
        if (error.response?.status === 400 && error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error(error.message || "error_password_change_failed");
    }
};

export const resetPassword = async (token, newPassword) => {
    try {
        const response = await api.post(
            "/reset_password",
            { token, "new_password":newPassword },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 200) {
            return true;
        } else {
            throw new Error("error_password_reset_failed");
        }
    } catch (error) {
        if (error.response?.status === 400 && error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error(error.message || "error_password_reset_failed");
    }
};

export const logout = async () => {
    try { await api.post('/v1/staff/auth/logout'); } catch (_) {}
    clearAccessToken();
};

export const isAuthenticated = () => false;

export const hasRole = () => false;
